import styled from 'styled-components';

export const Wrapper = styled.div`
    background: linear-gradient(86.45deg, #780eff -4.33%, #bf28ff 102.27%);
    padding: 1px;
    border-radius: 30px;
    overflow: hidden;
    display: inline-block;
    height: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Inner = styled.div<{ $bgColor?: string }>`
    border-radius: 30px;
    background: ${({ $bgColor }) => $bgColor || '#090719'};
    display: flex;
    height: 100%;
`;

export const Text = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    font-weight: 600;
    font-size: 9px;
    line-height: 9px;
    color: white;
    padding: 0 6px;
    text-transform: uppercase;
    background: linear-gradient(86.45deg, #780eff -4.33%, #bf28ff 102.27%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;
